// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 530 ? "page" : chunkId) + "." + {"169":"a641f047","286":"e274a5d9","530":"c760275b","680":"e274a5d9"}[chunkId] + ".css";
};